import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import 'react-datepicker/dist/react-datepicker.css'
import { formatarDataParaSalvar } from '../../utils/dataFormat'
import RenderAula from '../../components/renderAula.js'
import { DatePicker, Loading } from '../../components/all'
import useInstrutorStore from '../../store/useInstrutorStore'
import useInstrutor from '../../hooks/useInstrutor'

export default function ListAulasInstrutorView() {
  const { SearchAulasInstrutor, getHorariosDisponiveis } = useInstrutor()
  const { instrutor } = useInstrutorStore()

  const [loading, setLoading] = useState(false)
  const [aulas, setAulas] = useState([])
  const [error, setError] = useState(null)

  const handleDateChange = async (selectedDate) => {
    setLoading(true)
    setError(null)

    const formattedDate = formatarDataParaSalvar(selectedDate)
    const res = await getHorariosDisponiveis(instrutor.instrutor_id, formattedDate)

    try {
      let data = await SearchAulasInstrutor(instrutor.instrutor_id, formattedDate)
      data = [...data, ...res]

      data.sort((a, b) => {
        const [h1, m1] = (a.hora ? a.hora : a).split(':').map(Number)
        const [h2, m2] = (b.hora ? b.hora : b).split(':').map(Number)
        return h1 !== h2 ? h1 - h2 : m1 - m2
      })

      setAulas(data)
    } catch (err) {
      setError('Erro ao buscar aulas para a data selecionada.')
    } finally {
      setLoading(false)
    }
  }

  const renderAulaItem = (item) =>
    item.aula_id ? (
      <RenderAula key={item.aula_id} item={item} tipo={1} />
    ) : (
      <div
        key={item}
        className="
          flex items-center justify-between
          bg-green-50 border border-green-200
          text-green-800 rounded-xl p-3 shadow-sm
        "
      >
        <div className="flex items-center gap-2">
          <span className="material-icons text-green-600">schedule</span>
          <span className="font-medium">Horário livre</span>
        </div>
        <span className="font-semibold">{item}</span>
      </div>
    )

  return (
    <div className="min-h-[95vh] px-4 pt-6 pb-20 flex justify-center">
      <div className="w-full h-full flex flex-col gap-4 pb-20">
        {/* Header */}
        <div className="text-center">
          <p className="text-sm text-gray-500">Agenda do instrutor</p>
          <h1 className="text-2xl font-bold text-gray-900">Aulas</h1>
        </div>

        {/* Date Picker Card */}
        <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-200">
          <DatePicker onChange={handleDateChange} dias={7} />
        </div>

        {loading && <Loading />}

        {error || aulas.length === 0 ? (
          <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-xl text-center">
            <p>{error ? `Erro: ${error}` : 'Nenhuma aula marcada!'}</p>
          </div>
        ) : (
          <div className="flex flex-col gap-3 overflow-y-auto">
            {aulas.map(renderAulaItem)}
          </div>
        )}
        <button className='flex justify-center items-center gap-2' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          Voltar ao Topo
          <span className="material-icons">
            arrow_circle_up
          </span>
        </button>
      </div>
    </div>
  )
}
